// extracted by mini-css-extract-plugin
export default {"popup":"popup__iT6cy","popup--shown":"popup--shown__Yh1Uy","popup__content":"popup__content__+KD31"};